import React from 'react';
import './Manufacturingsmachi.css';
import PBmanufact from '../../../imgs/PBmanufact.webp';

const Manufacturingsmachi = () => {
  return (
    <div className="manufacturs-container">
      <div className="manufacturs-img">
        <img src={PBmanufact} alt="Manufacturing Machine" className="manufactu1" />
      </div>

      <div className="manufacturs-text">
        <h2>Manufacturing Machine</h2>
        <h3>PB680-S6</h3>
        <ul>
          <li> Daily Yield – 19200 pcs</li>
          <li>Cycle Time –  30 second(can be down to 20s by upgrad the injection system)</li>
          <li> Clamping Force –680ton</li>
          <li>Processing Temperature –320~330℃</li>
          <li> Power Consumption – 163kW/h</li>
        </ul>
        <p>
          PB Series plastic bucket injection molding machine are specialized for PP plastic bucket and box. Higher productivity and more stable production with improved machine which specialized for making storage box.
        </p>
        <button className="learn-btn">Learn More</button>
      </div>
    </div>
  );
};

export default Manufacturingsmachi;

